import React, { useState, useEffect, useRef, useContext } from "react";
import { ContentWrapper, SnackbarContent, PageTitle } from "../styled-components/shared";
import { Switch, Button } from "@zebra-fed/zds-react-desktop";
import Snackbar from "@material-ui/core/Snackbar";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";
import InputAdornment from '@material-ui/core/InputAdornment';
import firebaseUtil from "../data/FirebaseUtil";
import { DataContext } from "../data/DataContext";
import { useTranslation } from "react-i18next";
import BottomNavLinks from "../components/BottomNavLinks";
import { validate } from "@material-ui/pickers";
import { GPS_SETTINGS } from '../data/constants'

const StyledSpan = styled.span`
    display: flex;
    align-items: center;
    min-width: fit-content;
`;

const StyledContentWrapper = styled(ContentWrapper)`
  padding: 20px;
  @media screen and (max-width: 750px){
      overflow-x: hidden;
  }
`;

const SubHeader = styled.h2`
  font-size: 16px;
  color: #4c4c4c;
  margin: 0;
  line-height: 19px;
  font-weight: 600;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 500px;
  margin-bottom: 10px;
  & > *:first-child {
    flex: 1;
  }
`;

const ExpandedFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 850px;
  margin-bottom: 10px;
  & > *:first-child {
    flex: 1;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  max-width: 500px;
  align-items: center;
  justify-content: center;
`;

const CheckboxHolder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 228px;
`;

const CheckboxError = styled.p`
    width:100%;
    margin: 0;
    padding-left: 10px;
    font-size: 0.75rem;
    margin-top: 3 px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    color: red;
`;

const StyledTextField = styled(TextField)`
    width: 220px;
    display: flex;
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }
`;

export default function GPSLocationPage() {
    let { globalAppSettings, setGlobalAppSettings } = useContext(DataContext);
    const [appSettings, setAppSettings] = useState(globalAppSettings);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [checkErrors, setCheckErrors] = useState(false);

    const errors = useRef([]);
    const serverResponse = useRef("");

    const { t } = useTranslation()

    useEffect(() => {
        console.log("GPSLocationPage: @@@@@@@@@@@@@@@@@@@ globalAppSettings:", globalAppSettings)
    }, []);

    async function handleSave() {
        // TODO:
        // 1. Convert minutes/hours into seconds
        // 2. Minutes - incremental in 5 mins interval
        // 3. Hours - incremental in 1 hour

        //
        const reportingFrequencyInSeconds =  appSettings.reportingFrequency ? parseInt( appSettings.reportingFrequency) : GPS_SETTINGS.DEFAULT;

        // min: 5 mins; max: 24 hours
        if (reportingFrequencyInSeconds < GPS_SETTINGS.MIN || reportingFrequencyInSeconds > GPS_SETTINGS.MAX ) {
            setCheckErrors(!checkErrors);
            errors.current = errors.current.concat("reportingFrequencyInSeconds");
            console.log("GPSLocationPage: error: GPS reporting frequence is out of range: ", reportingFrequencyInSeconds );
        }

        //if (errors.current.length === 0) {
            // GPS loction configuration data need to write to Firestore
            let data = {
                enableGPSLocation: appSettings.enableGPSLocation,
                reportingFrequency: parseInt(appSettings.reportingFrequency)
            }

            // Write to Firestore
            setIsLoading(true);
            let response = await firebaseUtil.saveAppSettings(data);

            // Update global app settings
            setGlobalAppSettings({
                ...globalAppSettings,
                enableGPSLocation: appSettings.enableGPSLocation,
                reportingFrequency: appSettings.reportingFrequency
            })
            setIsLoading(false);
            serverResponse.current = response;
            setSnackbarOpen(true);
        //}
    }

    const ButtonStyle = {
        margin: "0",
        display: "flex",
        alignSelf: "flex-end",
        cursor: isLoading ? "wait" : "pointer",
    };

    return (
        <>
            <StyledContentWrapper
                style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1' }}>
                <PageTitle>{t('gpsLocationSettings')}</PageTitle>
                    <ExpandedFlexRow
                        style={{
                            display: "flex",
                        }}
                    >
                    </ExpandedFlexRow>

                    <FlexRow
                        style={{
                            display: "flex",
                        }}
                    >
                        <SubHeader>{t('gpsLocation') + ":"}</SubHeader>
                        <CheckboxHolder>
                            <Switch
                                checked={globalAppSettings.enableGPSLocation}
                                onChange={val => {
                                    setAppSettings({ ...appSettings, enableGPSLocation: val });
                                }}
                            />
                            <SubHeader>
                                {appSettings.enableGPSLocation === true ? t('enabled') : t('disabled')}
                            </SubHeader>
                        </CheckboxHolder>
                    </FlexRow>

                    <FlexRow
                        style={{
                            display: "none",
                        }}
                    >
                        <SubHeader>{t('gpsReportingFrequency') + ":"}</SubHeader>
                        <StyledTextField
                            // error={errors.current.includes("gpsReportingFrequency")}
                            placeholder={t('gpsReportingFrequencyHolder')}
                            type="number"
                            InputProps={{
                                endAdornment: <InputAdornment position="start">{t('workFlow.deviceThresholdValues.minutes')}</InputAdornment>,
                            }}                            
                            onChange={ e =>
                                setAppSettings({ ...appSettings , reportingFrequency:  e.target.value 
                                })
                            }
                            value={appSettings.reportingFrequency}
                            // helperText={
                            //     errors.current.includes("gpsReportingFrequency")
                            //         ? t('messages.error.err51')
                            //         : ""
                            // }
                        />
                    </FlexRow>

                    <ButtonContainer>
                        <Button
                            style={
                                isLoading ? { opacity: "0.7", ...ButtonStyle } : ButtonStyle
                            }
                            onClick={handleSave}
                            type="primary"
                            disabled={isLoading}
                        >
                            {t('save')}
                        </Button>
                    </ButtonContainer>

                <BottomNavLinks />
            </StyledContentWrapper>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={() => setSnackbarOpen(false)}
            >
                <SnackbarContent error={serverResponse.current.status ? false : true}>
                    {serverResponse.current.msg}
                </SnackbarContent>
            </Snackbar>
        </>
    );
}